import { FC } from 'react';
import { Icon, IconName } from '@frontend/icons';

export const FilterIcon: FC<{ name: IconName; isFilterActive: boolean }> = ({ name, isFilterActive }) => {
  return <Icon name={name} color={isFilterActive ? 'white' : 'default'} />;
};
